import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/untappd': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M401.3 49.9C321.5 210 316.7 202.4 313.4 223.1L308.2 255.9C306.3 267.9 301.6 279.4 294.5 289.3L145.6 497.1C138 507.7 125.2 513.3 112.2 511.7 71.9 506.7 34.4 479.5 16.9 443.2 11.2 431.4 12.4 417.4 20 406.8L168.9 198.9C176 189 185.3 180.9 196.1 175.2L225.4 159.7C243.9 149.9 235.1 147.8 361 20.8 362 16 362 13.5 364.6 12.8 367.6 12.1 371.2 11.8 370.9 8.2L370.5 3.6C370.3 1.7 371.8 0 373.7 0 378.2-0.1 386.9 1.2 399.3 10 411.6 18.9 415.7 26.8 417 31.1 417.6 32.9 416.4 34.8 414.6 35.3L410.1 36.4C406.7 37.3 407.6 40.8 407.8 43.8 407.9 46.6 405.5 47.4 401.3 49.9zM230.1 36.4C233.5 37.3 232.6 40.8 232.4 43.8 232.2 46.5 234.5 47.3 238.8 49.8 246.7 65.7 254.1 80.3 261 93.8 261.7 95.1 263.3 95.3 264.3 94.3 275.5 82.3 288.9 68.1 304.8 51.7 306.1 50.3 306.2 48.2 304.9 46.8 296.9 38.6 288.4 29.9 279.3 20.7 278.3 16 278.3 13.4 275.7 12.7 272.7 11.9 269.1 11.7 269.4 8.1 269.7 4.8 270.8 0 266.6-0.1 262.1-0.2 253.4 1 241 9.9 228.7 18.8 224.6 26.7 223.3 31 221.9 35.2 226.9 35.6 230.1 36.4zM620 406.7L471.2 198.8C458 180.3 444.6 175.4 414.8 159.7 403.6 153.8 400.6 148.8 384.3 130.8 383.3 129.7 381.4 129.9 380.7 131.3 334.4 220.1 333.6 214.1 331.7 226.1 330 236.8 330.4 246.1 332 255.9 333.9 267.9 338.6 279.4 345.7 289.3L494.6 497.2C502.2 507.8 514.8 513.4 527.7 511.9 568 507 605.7 479.9 623.4 443.3 628.8 431.4 627.7 417.4 620 406.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/untappd.js
// module id = Jd2R
// module chunks = 144